<template>
  <el-dialog
    :title="'导入任课关系 - ' + grade.name"
    :visible.sync="dialogVisible"
    custom-class="zyyj-dialog zyyj-d-upload"
    :close-on-click-modal="false"
    @close="closeDialog"
  >
    <span style="font-size: 14px; color: #757575; line-height: 20px"
      >文件上传：1、导入任课关系前请先下载模版，模版内包含班级与学生信息；2、导入任课关系前，请确保教师信息录入系统；3、一个学科有多个教师需要进行录入，单元格内使用分号“；”进行间隔；</span
    >
    <el-upload
      v-loading="loading"
      ref="upload"
      class="zyyj-d-u-el-upload"
      drag
      :action="action"
      accept=".xlsx"
      :data="{ grade: grade.value }"
      :headers="myHeaders"
      :show-file-list="false"
      :on-success="handleUploadSuccess"
      :on-error="handleUploadError"
      :before-upload="beforeUpload"
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">
        将文件拖到此处，或
        <em>点击上传</em>
      </div>
      <div v-if="uploadResult.code === 422" slot="tip" class="el-upload__tip">
        导入文件格式与模版不匹配，请重新确认
      </div>
      <div
        v-else-if="uploadResult.code === 'file_read_error'"
        slot="tip"
        class="el-upload__tip"
      >
        文件读取失败，请检查文件格式
      </div>
      <div
        v-else-if="uploadResult.code === 'file_empty'"
        slot="tip"
        class="el-upload__tip"
      >
        请检查文件大小和格式，或联系管理员
      </div>
      <div
        v-else-if="uploadResult.code === 'template_error'"
        slot="tip"
        class="el-upload__tip"
      >
        模版文件学科与系统学科不匹配，请调整后再试
      </div>
      <div
        v-else-if="uploadResult.code === 'class_not_match'"
        slot="tip"
        class="el-upload__tip"
      >
        模版文件班级与系统班级不匹配，请调整后再试
      </div>
      <div
        v-else-if="uploadResult.code === 400"
        slot="tip"
        class="el-upload__tip"
      >
        {{ uploadResult.data }}
      </div>
      <div
        v-else-if="uploadResult.data && uploadResult.data.failKey"
        slot="tip"
        class="el-upload__tip"
      >
        <div slot="tip" class="el-upload__tip" style="font-size: 14px;">
          <span
            style="color: var(--theme-color); cursor: pointer;"
            @click="downloadRecord"
          >
            点此下载失败记录
          </span>
        </div>
      </div>
    </el-upload>
    <el-row class="zyyj-fail-record-row" v-if="hasFails">
      <el-col :span="24">
        <el-table
          :data="uploadResult.data.failRecords"
          size="medium"
          border
          :header-cell-style="{ background: '#f9f9f9' }"
        >
          <!-- slot for the standard el-table-column elements here -->
          <slot name="if-failure"></slot>
        </el-table>
      </el-col>
    </el-row>
    <div slot="footer" class="dialog-footer">
      <el-button
        size="small"
        :disabled="loading"
        @click="handleDownloadTemplate"
        >下载模板</el-button
      >
      <el-button
        type="primary"
        :disabled="loading"
        size="small"
        @click="closeDialog"
        >关 闭</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
// import _ from 'lodash'

export default {
  props: ['topic', 'action', 'visible', 'template', 'errorUrl', 'grade'],

  data () {
    var token = localStorage.getItem('token')
    return {
      hasFails: false,
      uploadResult: {},
      myHeaders: { Authorization: 'Bearer ' + token },
      loading: false
    }
  },

  computed: {
    dialogVisible: {
      get () {
        return this.visible === true
      },
      set () {
        this.$emit('update:visible', false)
      }
    }
  },

  methods: {
    handleDownloadTemplate () {
      this.$fetchFile(`${this.template}`, {
        name: `导入任课关系模板`,
        grade: this.grade.value
      })
    },

    downloadRecord () {
      this.$fetchFile(`${this.errorUrl}`, {
        name: `导入任课关系失败记录`,
        failKey: this.uploadResult.data.failKey
      })
    },

    beforeUpload (file) {
      let isExcel =
        file.type ===
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
        file.name.endsWith('.xlsx')
      if (!isExcel) {
        this.$message.error('上传文件的后缀必须是.xlsx格式!')
      } else {
        this.loading = true
      }
      return isExcel
    },

    handleUploadSuccess (resp) {
      this.uploadResult = resp
      this.hasFails = resp.data && resp.data.failKey
      if (resp.data && resp.data.failRecords.length === 0) {
        this.$message.success('导入成功')
        setTimeout(() => {
          this.closeDialog()
        }, 500)
      }
      this.loading = false
    },

    handleUploadError () {
      /* un-excpect error */
      this.uploadResult = { data: { failKey: 'random' } }
      this.loading = false
    },

    closeDialog () {
      this.$emit('update:visible', false)
      this.$emit('import-result', true)
      this.$refs.upload.clearFiles()
      this.uploadResult = {}
      this.hasFails = false
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-upload__tip {
  margin-top: 20px;
  word-break: normal;
  line-height: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/school-admin/affair/ExcelImporterBox.vue